if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        // constructor内ではswiperはまだ未初期化のため何もしない
      }

      connectedCallback() {
  // まず1枚目をアクティブに
  const firstMedia = this.elements.viewer.querySelector('[data-media-id]');
  if (firstMedia) {
    this.setActiveMedia(firstMedia.dataset.mediaId, false);
  }

  // サムネイルが存在しなければ終了
  if (!this.elements.thumbnails) return;

  // 既存のslideChangedイベントは登録
  this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

  // swiper初期化確認＆イベント登録
  const setupSwiperEvents = () => {
    const slider = this.elements.viewer?.swiper;
    if (slider) {
      slider.on('slideChange', () => {
        const activeIndex = slider.activeIndex;
        const slides = this.elements.viewer.querySelectorAll('.product__media-item');
        if (slides.length > activeIndex) {
          const img = slides[activeIndex].querySelector('img');
          const altTextContainer = document.querySelector('#alt-text-container .alt-text-content');
          if (altTextContainer) {
            altTextContainer.textContent = img ? img.alt || '' : '';
          }
        }
      });
    } else {
      setTimeout(setupSwiperEvents, 1000);
    }
  };

  setupSwiperEvents();

 


        // サムネイルクリックのイベント登録は従来通り
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      // 以下は既存のメソッド群はそのまま
     onSlideChanged(event) {
  const thumbnail = this.elements.thumbnails.querySelector(
    `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
  );
  this.setActiveThumbnail(thumbnail);

  // ★ この行を追加（ないとaltテキストはスワイプ時に更新されません）
  const mediaId = event.detail.currentElement.dataset.mediaId;
  this.setActiveMedia(mediaId, false);
}


      //20260309 第三引数を追加
      setActiveMedia(mediaId, prepend, triggerTarget) {
        if (!mediaId) return;

        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        
        activeMedia.classList.add('is-active');

        // 202603追加
        if(activeMedia.getAttribute('data-media-position')){
          const currentNum = activeMedia.getAttribute('data-media-position');
          const mediaCounter = document.querySelector('#mediaCounter .media-counter-number .media-current');
          if(mediaCounter) {
            mediaCounter.textContent = `${currentNum}`;
          }
        }

        const altTextContainer = document.querySelector('#alt-text-container .alt-text-content');
        if (altTextContainer) {
          const img = activeMedia.querySelector('img');
          altTextContainer.textContent = img ? img.alt || '' : '';
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          if(triggerTarget){
            if(triggerTarget instanceof HTMLElement) {
              if(triggerTarget.getAttribute('name').trim() === 'size-2')return;
            }
          }
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);

        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
